<template>
  <section id="technology" class="tech">
    <div class="container">
      <div class="tech__header">
        <span class="section-label">TECHNOLOGY</span>
        <h2 class="section-title">核心技术能力</h2>
        <p class="section-desc">自研高性能绘画引擎，为创作者提供极致流畅的绘画体验</p>
      </div>
      <div class="tech__grid">
        <div class="tech__row">
          <div class="tech-card" v-for="(item, index) in techs.slice(0, 3)" :key="'r1-'+index">
            <div class="tech-card__icon-wrap">
              <img v-if="item.icon" :src="item.icon" :alt="item.title" class="tech-card__icon" />
              <span v-else class="tech-card__emoji">{{ item.emoji }}</span>
            </div>
            <h3 class="tech-card__title">{{ item.title }}</h3>
            <p class="tech-card__desc">{{ item.description }}</p>
          </div>
        </div>
        <div class="tech__row">
          <div class="tech-card" v-for="(item, index) in techs.slice(3)" :key="'r2-'+index">
            <div class="tech-card__icon-wrap">
              <img v-if="item.icon" :src="item.icon" :alt="item.title" class="tech-card__icon" />
              <span v-else class="tech-card__emoji">{{ item.emoji }}</span>
            </div>
            <h3 class="tech-card__title">{{ item.title }}</h3>
            <p class="tech-card__desc">{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import gpuIcon from '@/assets/icons/gpu.svg'
import canvasIcon from '@/assets/icons/canvas.svg'
import brushIcon from '@/assets/icons/brush.svg'
import layersIcon from '@/assets/icons/layers.svg'
import collaborationIcon from '@/assets/icons/collaboration.svg'
import devicesIcon from '@/assets/icons/devices.svg'

export default {
  name: 'TechSection',
  data() {
    return {
      techs: [
        { title: 'GPU 加速渲染', description: '基于 GPU 的并行计算能力，实现实时笔刷渲染与流畅的绘画体验', icon: gpuIcon },
        { title: '高性能画布', description: '深度优化画布渲染，毫秒级缩放与平移，超低延迟创作体验', icon: canvasIcon },
        { title: '笔刷引擎', description: '自研笔刷系统，100+画笔参数，真实模拟各类画笔材质与笔触效果', icon: brushIcon },
        { title: '高级图层系统', description: '支持图层组、混合模式、蒙版、剪贴蒙版等专业功能', icon: layersIcon },
        { title: '多人协作绘制', description: '茶绘功能支持多人在同一个画布实时协作绘画，边绘画边交流', icon: collaborationIcon },
        { title: '跨平台能力', description: 'iOS / Android / PC 多平台覆盖，统一创作体验', icon: devicesIcon }
      ]
    }
  }
}
</script>

<style scoped>
.tech {
  padding: 100px 0;
}

.tech__header {
  text-align: center;
  margin-bottom: 48px;
}

.tech__grid {
  display: flex;
  flex-direction: column;
}

.tech__row {
  display: flex;
  margin-left: -10px;
  margin-right: -10px;
}

.tech__row + .tech__row {
  margin-top: 20px;
}

.tech-card {
  flex: 1;
  background-color: #141419;
  border-radius: 16px;
  padding: 28px;
  display: flex;
  flex-direction: column;
  margin: 0 10px;
}

.tech-card__icon-wrap {
  width: 40px;
  height: 40px;
  background-color: #1E1E2A;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.tech-card__emoji {
  font-size: 20px;
}

.tech-card__icon {
  width: 20px;
  height: 20px;
}

.tech-card__title {
  font-family: 'Inter', sans-serif;
  font-size: 18px;
  font-weight: 600;
  color: #FFFFFF;
  margin-bottom: 12px;
}

.tech-card__desc {
  font-family: 'Inter', sans-serif;
  font-size: 15px;
  font-weight: 400;
  line-height: 22px;
  color: #9CA3AF;
}

@media (max-width: 1024px) {
  .tech {
    padding: 80px 0;
  }
  .tech__header {
    margin-bottom: 40px;
  }
  .tech-card {
    padding: 20px;
  }
  .tech-card__title {
    font-size: 16px;
  }
  .tech-card__desc {
    font-size: 14px;
    line-height: 20px;
  }
  .tech__row {
    margin-left: -8px;
    margin-right: -8px;
  }
  .tech-card {
    margin: 0 8px;
  }
}

@media (max-width: 768px) {
  .tech {
    padding: 60px 0;
  }
  .tech__header {
    margin-bottom: 32px;
  }
  .tech__grid {
    gap: 16px;
  }
  .tech__row {
    flex-direction: column;
    margin: 0;
    gap: 16px;
  }
  .tech__row + .tech__row {
    margin-top: 0;
  }
  .tech-card {
    margin: 0;
    padding: 20px;
  }
  .tech-card__title {
    font-size: 16px;
  }
  .tech-card__desc {
    font-size: 13px;
    line-height: 18px;
  }
}

@media (max-width: 480px) {
  .tech {
    padding: 48px 0;
  }
  .tech-card {
    padding: 16px;
  }
}
</style>
